<div class="day-selector-container" [class.auto-sked]="autoSked">
  @for (day of weekData; track day; let i = $index) {
    <div
      class="day-block"
      [ngClass]="{
        selected: isChecked(day.value, i),
        unselected: !isChecked(day.value, i),
        'green-border': selectedGreenBorder && isChecked(day.value, i)
      }"
      [class.error]="(isInvalid(day.value) && control.touched) || allInvalid"
      [class.disabled]="disabledIndexArr.includes(i)"
      [class.light-bg]="lightBackground"
      (click)="changeValue(day.value, i)"
    >
      <span>{{ day.label }}</span>
    </div>
  }
</div>
